<template>
    <div class="mainPage">
        <div class="agentTip" v-if="!isChrome">
            <span>建议使用Chrome浏览器，以获得最佳体验</span>
            <div class="closeTip" @click="isChrome = true">×</div>
        </div>
        <div class="header_banner">
            <div class="header">
                <div class="content">
                    <div class="left">
                        <img src="../img/chinesebridge/camp_icon.png" alt="" class="camp">
                        <div class="schoolInfo">
                            <img :src="subject_info.extra.schoolLogo" alt="" v-if="subject_info.extra&&subject_info.extra.schoolLogo" class="logo">
                            <div class="name_en" :class="{'long_name':subject_info.name_en.length > 140}" v-if="subject_info.name_en">
                                {{subject_info.name_en}}
                            </div>
                            <div class="name" :class="{'long_name':subject_info.name_en.length > 140}">
                                {{subject_info.name}}
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <div v-if="!isLogin" class="loginInfo">
                            <p @click="toLogin()" class="btn">
                                <span class="content">
                                    Join Now
                                    <span>
                                        注册
                                    </span>
                                </span>
                            </p>
                            <p @click="toLogin()" class="btn">
                                <span class="content">
                                    Login
                                    <span>
                                        登录
                                    </span>
                                </span>
                            </p>
                        </div>
                        <div v-if="isLogin" class="loginInfo">
                            <p class="btn person">
                                <span class="content">
                                    <img src="../img/chinesebridge/person.png" alt="">
                                    {{user.username}}
                                    <img src="../img/chinesebridge/exit.png" alt="" class="exitIcon" @click="toLogOut()">
                                </span>
                            </p>
                        </div>
                        <div class="bgRight">
                            <img src="../img/chinesebridge/bg_right.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="courseListCon">
            <div class="liveClass">
                <img src="../img/chinesebridge/liveclass.png" alt="">
            </div>
            <div class="course_con" v-for="(v, i) in courseList" :key="i">
              <div class="meet_date" :id="v.date" @click="spreadMeet(v)">
                <div class="date">{{v.date}}</div>
                <div class="arrow">{{v.sonShow ? '一' : '+'}}</div>
              </div>
              <ul class="list" v-show="v.sonShow">
                  <li v-for="(item, index) in v.list" :key="item.id" :class="{'live': item.customStatus == 1, 'finished': item.customStatus == 2}">
                      <div class="timeCon" >
                          <span class="time">{{new Date(+item.start_time).Format('YYYY.MM.DD hh:mm')}}-{{new Date(+item.end_time).Format('hh:mm')}}</span>
                          <span class="status live" v-if="item.customStatus2 == 1 && item.customStatus !== 2">
                              Live 直播进行中
                          </span>
                          <span class="status finished" v-if="item.customStatus == 2">
                              Finished 直播已结束
                          </span>
                      </div>
                      <div class="nameCon">
                          <div class="name name_en" v-if="item.name_en">
                              <span>
                                  {{item.name_en}}
                              </span>
                          </div>
                          <div class="name" v-if="item.name">
                              <span>
                                  {{item.name}}
                              </span>
                          </div>
                      </div>
                      <div class="titleCon">
                          <div class="title">
                              <div class="en" v-if="item.teacher_name_en">
                                  {{item.teacher_name_en}}
                              </div>
                              <div class="cn" v-if="item.teacher_name">
                                  {{item.teacher_name}}
                              </div>
                          </div>
                          <div class="liveBtn">
                              <!-- <span class="join" v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == false" @click="join(item, index, false)">
                                  <span class="En">
                                      Join
                                  </span>
                                  <span class="Cn">
                                      加入
                                  </span>
                              </span> -->
                              <span class="join replay" v-if="item.status == 3" @click="replay(item)">
                                  <span class="En">
                                      Replay
                                  </span>
                                  <span class="Cn">
                                      课程回放
                                  </span>
                              </span>
                              <span class="isOrder" v-if="item.status == 1 && item.customStatus == 0" >
                                  直播未开始 Coming Soon
                              </span>
                              <span class="join" v-if="item.status == 1 && item.customStatus == 1" @click="joinToLive(item, index)">
                                  <span class="En">
                                      Enter
                                  </span>
                                  <span class="Cn">
                                      进入
                                  </span>
                              </span>
                          </div>
                      </div>
                  </li>
              </ul>
            </div>
        </div>
        <div class="footer">
            <div>
                <img src="../img/chinesebridge/chinesebridge_logo.png" alt="">
            </div>
            <div class="copyright">
                版权所有：中外语言交流合作中心 中文联盟
            </div>
        </div>
        <transition name="fade">
        <div id="videoPlayWrapper" v-if="isPlay">
            <div class="videoContent">
            <div class="closeVideo" @click="closeVideo()">×</div>
						<div class="videoContainer">
							<!-- 普通视频 -->
							<video :src="currentVideoUrl" id="liveVideo" controls controlsList="nodownload" v-if='video_type==1'></video>
							<!-- 点播视频 -->
							<template v-else>
								<TCPlayer :options="options" style="width: 80%; height: 700px; margin: auto;" ></TCPlayer>
							</template>
						</div>
            </div>
        </div>
        </transition>
    </div>
</template>

<script>
import Qs from 'qs'
import TCPlayer from './common/TCPlayer'
export default {
    name: 'chinesebridge',
    components: {
			TCPlayer
    },
    data: function () {
        return {
					options:{
							fileID: "",
							appID: "1500035244",
							autoplay: true,
							psign:"",
						},
            isChrome: true,
            isLogin: false,
            isPlay: false,
            currentVideoUrl: '',
						video_type: '',
            user: {
                username: '',
                email: ''
            },
            subject_info: {},
            courseList: [],
            subject_id: null,
            beforeTime: 30, // 提前可进入直播间时间
            beforeTime2: 0, // 提前可进入直播间时间
            afterTime: 30 // 延后关闭直播间时间
        }
    },
    methods: {
        tolive (url) {
            window.open(url)
        },
        toLogin() {
            window.location.href =
            this.baseUrl +
            "user/api/login?" +
            "callback=" +
            encodeURIComponent(window.location.href);
        },
        toRegister() {
            window.location.href = 'https://passport.chinesecio.com/static/frontend/dist/#/pc/register?callback=' + encodeURIComponent(window.location.href);
        },
        customCheckLogin() {
            this.checkLogin().then(res => {
                if(res.data.success){
                    this.isLogin = true
                    this.user = res.data.data
                } else {
                    this.isLogin = false
                }
                this.getCourseInfo(this.subject_id)
            }).catch((r) => {
                console.log(r)
            })
        },
        toLogOut() {
            this.$utils.get('/user/api/logout').then(res => {
                if(res.data.success) {
                    this.isLogin = false
                }
            })
        },
        // 获取专题信息
        getSubjectInfo(id) {
            this.$utils.get('/subject/subject/read', {
                id: id
            }).then(res => {
                if(res.data.success) {
                    this.subject_info = res.data.data
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        spreadMeet (v) {
          this.$set(v, 'sonShow', !v.sonShow)
          // this.meetShowMap.forEach((v, i) => {
          //   if (index == i) this.$set(v, 'sonShow', !v.sonShow)
          //   else this.$set(v, 'sonShow', false)
          // })
        },
        // 获取课程列表
        getCourseInfo(id) {
            this.$utils.get('/subject/lesson/getlist', {
                subject_id: id,
                limit: 200,
                type: 'date'
            }).then(res => {
                if(res.data.success) {
                    var now = new Date().getTime()
                    var endTime = now - this.afterTime * 60 * 1000;
                    var nowBeforeFiveMin = now + this.beforeTime * 60 * 1000
                    var nowBeforeFiveMin2 = now + this.beforeTime2 * 60 * 1000
                    res.data.data.list.forEach(item => {
                      item.sonShow = new Date().Format('YYYY-MM-DD') == item.date ? true : false
                      item.list.forEach(e => {
                        e.isOrder = false
                        e.customStatus = 0
                        e.customStatus2 = 0
                        if (nowBeforeFiveMin > e.start_time) {
                            e.customStatus = 1 // 0:直播未开始 1:正在直播 2：直播已结束
                        }
                        if (endTime > e.end_time) {
                            e.customStatus = 2
                        }

												if (nowBeforeFiveMin2 > e.start_time) {
                            e.customStatus2 = 1 // 0:直播未开始 1:正在直播 2：直播已结束
                        }
                      })
                    })
                    this.courseList = res.data.data.list
                    var sonShowFlag = this.courseList.every(item => !item.sonShow)
                    if (sonShowFlag) {
                      if (new Date().getTime() < this.courseList[0]['list'][0].start_time) {
                        this.courseList[0].sonShow = true
                      } else if (new Date().getTime() > this.courseList[this.courseList.length - 1]['list'][0].end_time) {
                        this.courseList[this.courseList.length - 1].sonShow = true
                      } else {
                        this.findDate(new Date().Format('YYYY-MM-DD'))
                      }
                    }
                    this.$nextTick(() => {
                      this.courseList.forEach(item => {
                        item.sonShow && this.hashJump(item.date)
                      })
                    })
                    // this.checkOrdeList()
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        findDate (chartDate) {
          var dateIndex = this.courseList.findIndex(item => {
            return chartDate == item.date
          })

          if (dateIndex == -1) {
            var nextDate = new Date(new Date(chartDate).getTime() + 86400000).Format('YYYY-MM-DD')
            this.findDate(nextDate)
          } else {
            this.courseList[dateIndex].sonShow = true
          }
        },
        // 跳转锚点
        hashJump (id) {
          try {
            // window.document.getElementById(id).scrollIntoView(true)
            var distance = window.document.getElementById(id).offsetTop
            window.scrollTo({
              top: distance - 200,
              behavior: "auto",
            })
          } catch (err) {
          }
        },
        // 检查可预约直播间
        checkOrdeList() {
            const orderRoomId = []
            this.courseList.forEach(e => {
                if (orderRoomId.indexOf(e.room_id) == -1 && e.room_id != 0) {
                    orderRoomId.push(e.room_id)
                }
            })
						// debugger
            this.checkRoomsIsOrder(orderRoomId)
        },
        // 检查用户直播间状态
        checkRoomsIsOrder(arr) {
            const data = Qs.stringify({
                rooms: arr.toString(),
                user: this.user.email
            })
            this.$utils.thirdPost('https://mooc-live.chineseplus.net/api/live/get-user-rooms'+"?time=" +new Date().valueOf(), data, {
                headers: {
                    'Content-Type': 'application/json'
										// 'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                if (res.data.code == 0) {
                    this.courseList.forEach((e, index) => {
                        if (res.data.data.hasOwnProperty(e.room_id)) {
                            this.courseList[index].isOrder = true
                            this.$set (this.courseList, index, this.courseList[index])
                        }
                    })
                } else {
									this.$message.error(res.data.msg)
								}
            })
        },
        join(item, index, islive) {
            if(!this.isLogin) {
                this.toLogin()
                return
            }
            const data = Qs.stringify({
                room_id: item.room_id,
                user: this.user.email,
                secret: "faaf827fa8e4941ad5317a5a0b0f9649",
                key: "mooc",
                username: this.user.username,
                realname: this.user.username
            })
            this.$utils.thirdPost('https://mooc-live.chineseplus.net/api/live/add-user'+"?time=" +new Date().valueOf(), data, {
                headers: {
									  // 'Content-Type': 'application/json'
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                if (res.data.code == 0) {
                    this.courseList[index].isOrder = true
                    this.$set (this.courseList, index, this.courseList[index])
                    if (islive) {
                        window.location.href = 'https://mooc-live.chineseplus.net/p/#/?meeting_id=' + item.room_id
                    }
                } else {
									this.$message.error(res.data.msg)
								}
            }).catch((r) => {
                console.log(r)
            })
        },
        joinToLive(item, index) {
            if(!this.isLogin) {
                this.toLogin()
                return
            }
            // if(!item.isOrder) {
            //     this.join(item, index, true)
            // }
						else {
                window.location.href = 'https://mooc-live.chineseplus.net/p/#/?meeting_id=' + item.room_id
            }
        },
        async replay(item) {
            if(!this.isLogin) {
                this.toLogin()
                return
            }
            this.currentVideoUrl = item.video_url
						this.video_type = item.video_type
						// 点播获取视频签名
						if(item.video_type == 2){
							let res = await this.$utils.get("/subject/lesson/getvideoauth", {
								vid: item.video_id,
							});
							if (res.data.success) {
								this.options.fileID = item.video_id;
								this.options.psign = res.data.data;
							}
						}
						this.isPlay = true
            // setTimeout(function() {
            //     $('#liveVideo').bind('contextmenu',function() { return false; })
            // }, 50)
        },
        closeVideo() {
            var myvideo = document.getElementById("liveVideo");
            if (myvideo && !myvideo.paused) {
                myvideo.pause();
            }
            this.isPlay = false
        },
        checkChrome() {
            var isChrome = window.navigator.userAgent.indexOf("Chrome") > -1;
            if (!isChrome) {
                this.isChrome = false
            }
        }
    },
    mounted() {
        this.subject_id = this.$route.query.id
        this.customCheckLogin()
        this.getSubjectInfo(this.subject_id)
        this.checkChrome()
    }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">

.mainPage {
    width: 100%;
    text-align: center;
    position: relative;
    min-height: 100%;
    background-image: url(../img/chinesebridge/bg.png);
    .agentTip {
        width: 100%;
        height: 70px;
        line-height: 70px;
        background-color: #ffe6a1;
        text-align: center;
        position: absolute;
        z-index: 5;
        color: #c40000;
    }
    .agentTip .closeTip {
        position: absolute;
        right: 24px;
        top: 0px;
        font-size: 30px;
        color: #282828;
        cursor: pointer;
    }
    .header_banner {
        width: 100%;
        position: relative;
        height: 451px;
        overflow: hidden;
        .header {
            background: url(../img/chinesebridge/bridge_bg.png);
            width: 1920px;
            height: 451px;
            background-size: cover;
            position: absolute;
            left: 50%;
            top: 0;
            margin-left: -960px;
            .content {
                width: 1200px;
                padding-top: 68px;
                margin: auto;
                text-align: left;
                .left {
                    display: inline-block;
                    padding-top: 10px;
                    .camp {
                        width: 410px;
                    }
                    .schoolInfo {
                        margin-top: 20px;
                        margin-left: 107px;
                        .logo {
                            height: 70px;
                        }
                        .name_en {
                            width: 580px;
                            margin: 11px 0 11px;
                            font-size: 24px;
                            color: #004b9d;
                            font-family: DINCond-Medium;
                        }
                        .name {
                            width: 580px;
                            font-size: 24px;
                            color: #004b9d;
                            font-weight: bold;
                            line-height:1.2;
                        }
                        .long_name {
                            font-size: 22px;
                            margin-top: 3px;
                        }
                    }
                }
                .right {
                    display: inline-block;
                    text-align: right;
                    float: right;
                    vertical-align: top;
                    .loginInfo {
                        margin-right: 60px;
                    }
                    .btn {
                        display: inline-block;
                        width: 164px;
                        height: 60px;
                        background: #fff;
                        border-radius: 30px;
                        text-align: center;
                        position: relative;
                        z-index: 1;
                        margin-right: 20px;
                        cursor: pointer;
                        .content {
                            display: block;
                            width: 100%;
                            height: 100%;
                            text-align: center;
                            color: #60b9f4;
                            font-size: 28px;
                            font-family: 'DIN-BlackItalic';
                            padding-top: 5px;
                            position: relative;
                            box-sizing: border-box;
                            z-index: 1;
                            align-items: center;
                            &:before {
                                content: '';
                                position: absolute;
                                width: 154px;
                                height: 54px;
                                border: 3px solid #7ecef4;
                                left: 5px;
                                top: 4px;
                                border-radius: 27px;
                                box-sizing: border-box;
                            }
                            span {
                                color: #60b9f4;
                                font-size: 16px;
                                font-family: '微软雅黑';
                                font-weight: bold;
                                display: block;
                                position: relative;
                                letter-spacing: 4px;
                                margin-top: 2px;
                            }
                        }
                    }
                    .person {
                        width: auto;
                        line-height: 55px;
                        position: relative;
                        cursor:initial;
                        .content {
                            width: auto;
                            padding: 0 20px;
                            padding-right: 50px;
                            font-size: 18px;
                            color: #7ecef4;
                            font-weight: normal;
                            font-family: MicrosoftYaHei;
                            img {
                                vertical-align: middle;
                            }
                            &:before {
                                width: calc(100% - 10px);
                                left: 5px;
                                top: 3px;
                            }
                            .exitIcon {
                                position: absolute;
                                top: 0;
                                right: -15px;
                                bottom: 0;
                                margin: auto;
                                cursor: pointer;
                            }
                        }
                        
                    }
                    .bgRight {
                        position: relative;
                        top: -40px;
                    }
                }
                
            }
        }
    }
    .courseListCon {
        width: 1200px;
        min-height: 400px;
        margin: auto;
        background-color:#fff;
        border-radius: 30px;
        border: 5px solid #7ecef4;
        margin-top: -60px;
        .course_con {
          margin-bottom: 15px;
          padding: 0 20px;
        }
        .meet_date {
          overflow: hidden;
          background-color: #ffffff;
          border-radius: 10px;
          border: solid 3px #7ecef4;
          cursor: pointer;
          font-size: 40px;
          font-weight: bold;
          padding: 20px 30px;
          &:hover {
            background-color: #7ecef4;
            .date {
              color: #fff;
            }
            .arrow {
              color: #fff;
            }
          }
          .date {
            font-family: DIN-Bold;
            font-weight: bold;
	          font-size: 30px;
            color: #55add7;
            float: left;
            margin-top: 5px;
          }
          .arrow {
            float: right;
            margin-top: -2px;
            cursor: pointer;
            color: #55add7;
          }
        }
        .liveClass {
            padding-top: 60px;
            margin-bottom: 58px;
        }
        .list {
            position: relative;
            padding: 0 50px;
            text-align: left;
            margin: 30px 0;
            margin-bottom: 100px;
            &:before {
                position: absolute;
                left: 62px;
                width: 5px;
                height: calc(100% + 66px);
                content: '';
                background-color: #7ecef4;
            }
            li {
                margin-left: 47px;
                margin-bottom: 66px;
                position: relative;
                &:before {
                    position: absolute;
                    left: -47px;
                    top: -6px;
                    content: '';
                    width: 30px;
                    height: 30px;
                    box-sizing: border-box;
                    border-radius: 50%;
                    border: 5px solid #7ecef4;
                    background-color: #fad46b;
                }
                .timeCon {
                    .time {
                        font-size: 24px;
                        color: #5e696d;
                        font-family: "DIN-Medium";
                    }
                    .live {
                        font-size: 16px;
                        color: #379346;
                        margin-left: 60px;
                    }
                    .finished {
                        font-size: 16px;
                        color: #93a4aa;
                        margin-left: 60px;
                    }
                }
                .nameCon {
                    margin-top: 31px;
                    margin-bottom: 28px;
                    .name {
                        font-size: 24px;
                        line-height: 1.2;
                        color: #364347;
                        width: 924px;
                    }
                    .name_en {
                        font-size: 30px;
                        line-height: 1.2;
                        color: #5e696d;
                        margin-bottom: 8px;
                        font-family: 'Georgia';
                        width: 924px;
                    }
                }
                .titleCon {
                    .title {
                        color: #009dcd;
                        display: inline-block;
                        .en {
                            font-size: 24px;
                            font-family: 'Georgia';
                            margin-bottom: 2px;
                            width: 800px;
                            line-height: 1.2;
                        }
                        .cn {
                            font-size: 18px;
                            width: 800px;
                            line-height: 1.2;
                        }
                    }
                    .liveBtn {
                        float: right;
                        display: inline-block;
                        font-family: 'Georgia';
                        color: #282828;
                        .join {
                            display: inline-block;
                            height: 50px;
                            line-height: 1.2;
                            border-radius: 25px;
                            background-color: #fcb922;
                            padding: 15px 31px;
                            box-sizing: border-box;
                            cursor: pointer;
                            .En {
                                font-size: 22px;
                                vertical-align: top;
                            }
                            .Cn {
                                font-size: 20px;
                                vertical-align: top;
                            }
                        }
                        .replay {
                            background-color: #7ecef4;
                        }
                        .isOrder {
                            color: #999;
                        }
                    }
                }
            }
            .live:before {
                background-color: #43fd61;
            }
            .finished:before {
                background-color: #d6e1e5;
            }
        }
    }
    .footer {
        height: 370px;
        padding-top: 98px;
        box-sizing: border-box;
        background-image: url(../img/chinesebridge/footer_bg.png);
        background-size: cover;
        position: relative;
        .copyright {
            color: #fff;
            margin-top: 66px;
            font-size: 18px;
        }
    }
    #videoPlayWrapper {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 999;
        }
    #videoPlayWrapper .closeVideo {
        position: absolute;
        right: 20px;
        top: 10px;
        font-size: 50px;
        color: #fff;
        cursor: pointer;
    }
    .videoContent {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .videoContainer {
        text-align: center;
        width: 100%;
    }
    .videoContainer video {
        width: 62%;
    }
    video::-internal-media-controls-download-button {
        display:none;
    }
    video::-webkit-media-controls-enclosure {
        overflow:hidden;
    }
    video::-webkit-media-controls-panel {
        width: calc(100% + 30px);
    }
}

</style>
